<template>
    <b-container fluid>
        <light-box :album_id="viewingAlbum"
                   :class="{ 'hidden': !lightboxActive, 'show': lightboxActive }"
                   class="fade"
                   @close="lightboxActive ? lightboxActive = false : ''"
                   ref="lightbox"/>
        <b-container class="bg-light pt-2 mt-4">
            <page-heading heading ="Gallery"/>
                <div class="row pb-5">
                    <div class="col-md-4 col-sm-4" v-for="album in albums">
                        <div class="card-stack card-stack-10 stacked--fan-left mt-4 mx-3" 
                             :id="album.id" 
                             @click="selectedAlbum(album.id)"
                             style="cursor: pointer">
                            <div class="content pb-1">
                                <img class="card-img py-3 px-3" :src="album.images[0]" alt="Card image">
                                <div class="card-img-overlay"></div>
                                <p class="lead text-dark">{{ album.name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
        </b-container>
    </b-container>
</template>
<script>
import axios from 'axios'
import LightBox from '@/components/SharedComponents/LightBox.vue'
import PageHeading from '@/components/SharedComponents/PageHeading.vue'
export default {
    data() {
        return{
            albums: [],
            lightboxActive: false,
            viewingAlbum: 0
        }
    },
    methods: {
        getAlbums() {
            axios.get(this.API_URL + '/albums').then((response) => {
                this.albums = response.data
            }, (error) => {
                console.log(error)
            })
        },
        
        selectedAlbum(id){
            this.viewingAlbum = id
            this.lightboxActive = !this.lightboxActive
            let path = this.API_URL + '/albums/' + id
            this.$refs.lightbox.getAlbumImages(path)
            
        }
    },
    beforeCreate() {
        document.title = "Gallery"
    },
    created() {
        
    },
    beforeMount() {
        
    },
    mounted() {
        this.getAlbums()
    },
    beforeUpdate() {
        
    },
    updated() {

    },
    components: {
        LightBox,
        PageHeading
    }
}
</script>

<style scoped>
    .hidden {
        z-index: -9999;
    }
</style>



// WEBPACK FOOTER //
// src/components/gallery.vue